import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSurfingNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <clipPath id="sports_surfing_normal_medium_svg__a">
        <path d="M0 0h32v32H0z" />
      </clipPath>
      <g clipPath="url(#sports_surfing_normal_medium_svg__a)">
        <path
          d="M11.986 32l.7-.643c.183-.167 4.527-4.211 9.433-13.438C27.163 8.432 25.62 2.74 24.699.685l-.327-.6-.647.115c-2.165.379-7.746 2.283-12.791 11.77-4.906 9.23-5.828 15.092-5.865 15.337l-.142.94h4.527zM23.754 3.093c.519 2.47.59 7.153-3.08 14.058a58.324 58.324 0 01-8.423 12.316l-1.408-2.088 12.91-24.286zM6.879 26.61a58.333 58.333 0 015.5-13.87c3.669-6.9 7.588-9.46 9.928-10.412L9.4 26.61z"
          fill=""
        />
      </g>
    </svg>
  )
);
SvgSportsSurfingNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsSurfingNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSurfingNormalMedium;
